<template>
	<div class="modal-wrapper">
		<template v-if="options.sport">
			<div class="warning-container flex-center">
				<div class="warning-modal-body" v-html="$t('modals.wizardSportCameraInfo.mainText', { sport: options.sport})" />
				<button class="warning-btn button-light-blue" @click="onConfirm">
					{{ $tc('modals.wizardSportCameraInfo.okButton') }}
				</button>
			</div>
		</template>
		<template v-if="options.camera">
			<div class="accessory-container bg-white">
				<div class="flex justify-end pt-20 pr-20">
					<button class="modal-btn" @click="onClose" v-text="'X'" />
				</div>
				<div class="modal-row flex">
					<div class="accessories-img">
						<img
							:alt="options.camera.metadata.cameraType"
							:src="`/my/images/${options.camera.metadata.cameraType}-camera-colour-small.png`"
						>
					</div>
					<div class="modal-text mt-10 ml-20">
						<div class="modal-title small-text font-medium mb-10">
							{{ $tc('modals.wizardSportCameraInfo.actionTitle') }}
						</div>
						<div class="modal-body small-sm-text mr-5" v-html="$t('modals.wizardSportCameraInfo.actionInfo')" />
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import { ModalMixin } from '~/assets/vue/mixins'

export default {
	name: 'ModalWizardSportCameraInfo',
	mixins: [ModalMixin],
	props: {
		options: {
			type: Object,
			required: true
		}
	}
}
</script>
<style lang="scss" scoped>
	.accessory-container {
		min-height: 300px;

		.modal-row {
			padding: 14px;

			.accessories-img {
				margin-top: 10px;
			}
		}
	}
</style>
